import { ReactElement } from 'react';
import { Logo as CoreLogo } from '@client/common/components/Logo';

export const Logo = ({ className }: { className?: string }): ReactElement => (
  <CoreLogo shop='Brack Business' className={className} />
);
